import { ref } from "vue";
const paymentLoader = ref(false);

const setPaymentLoader = (value: boolean) => paymentLoader.value = value;

export {setPaymentLoader, paymentLoader}